export default __webpack_public_path__ + "static/media/Mentor-and-monitoring.92ebea19.png";